import React, { createContext, useState, useContext } from 'react';

const AuthFlowContext = createContext();

export const AuthFlowProvider = ({ children }) => {
  const [authFlow, setAuthFlow] = useState('login'); // 'login' or 'register'

  const toggleAuthFlow = () => {
    setAuthFlow((prev) => (prev === 'login' ? 'register' : 'login'));
  };

  return (
    <AuthFlowContext.Provider value={{ authFlow, setAuthFlow, toggleAuthFlow }}>
      {children}
    </AuthFlowContext.Provider>
  );
};

export const useAuthFlow = () => useContext(AuthFlowContext);
